var rtl_default = {
  "rtl": "-Xe5S",
  "ltr": "-IptJ"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
